import { useCallback, useEffect, useState } from "react";
import { GrChip } from "@jnpmedi/grebob";
import { FileDetailViewerContextPageInfo, useFileDetailViewerContext } from "@newHooks/context/viewer/fileDetailViewer.context";

export function FileDetailViewerNavigation({ totalPages }: { totalPages?: number }) {
  const { addPageInfoDelegate, removePageInfoDelegate } = useFileDetailViewerContext();
  const [pageInfo, setPageInfo] = useState<FileDetailViewerContextPageInfo>({ current: 0, total: totalPages || 0 });

  const pageInfoDelegate = useCallback((info: FileDetailViewerContextPageInfo) => {
    setPageInfo(info);
  }, []);

  useEffect(() => {
    addPageInfoDelegate(pageInfoDelegate);

    return () => {
      removePageInfoDelegate(pageInfoDelegate);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <GrChip size="large" color="grey" variant="outlined" shape="circle" label={`${pageInfo.current || 1} / ${pageInfo.total || 1}`} />;
}
